/* Product page: variants, gallery, zoom, sticky bar, share, recently viewed. */
(function () {
  var root = document.querySelector('[data-pd]'); if (!root || root._p) return; root._p = 1;
  var $ = function (s, r) { return (r || root).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var data = JSON.parse(($('[data-pd-json]') || {}).textContent || '{}');
  var form = $('[data-pd-form]'), track = $('[data-pd-track]');
  var money = function (c) { return window.CC ? CC.money(c) : c / 100; };

  /* gallery */
  var slides = $$('[data-pd-slide]'), countEl = $('[data-pd-count]');
  function current() { if (!track) return 0; return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
  function goTo(i, smooth) { if (!track || !slides[i]) return; track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' }); }
  function paint() { var i = current(); if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length; $$('[data-pd-thumb]').forEach(function (t, k) { t.setAttribute('aria-current', k === i); }); }
  if (track) track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pd-thumb]'); if (t) { goTo(+t.dataset.pdThumb); return; }
    if (e.target.closest('[data-pd-prev]')) { goTo(Math.max(0, current() - 1)); return; }
    if (e.target.closest('[data-pd-next]')) { goTo(Math.min(slides.length - 1, current() + 1)); return; }
    var s = e.target.closest('[data-pd-slide]'); if (s) { openZoom(s.dataset.full, s.querySelector('img') && s.querySelector('img').alt); return; }
    if (e.target.closest('[data-pd-share]')) { e.preventDefault(); share(); }
  });

  /* zoom viewer */
  function openZoom(src, alt) {
    if (!src) return;
    var z = document.createElement('div'); z.className = 'pd-zoom'; z.setAttribute('role', 'dialog'); z.setAttribute('aria-modal', 'true'); z.setAttribute('aria-label', 'Zoomed photo');
    z.innerHTML = '<button class="pd-zoom__x" type="button" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button><img alt=""><span class="pd-zoom__hint">Tap to zoom</span>';
    var img = z.querySelector('img'); img.src = src; img.alt = alt || '';
    document.body.appendChild(z); document.body.classList.add('c-lock');
    var zoomed = false, sx = 0, sy = 0, tx = 0, ty = 0, drag = false, moved = false, startY = null;
    function apply() { img.style.transform = zoomed ? 'translate(' + tx + 'px,' + ty + 'px) scale(2.4)' : ''; }
    function close() { z.remove(); document.body.classList.remove('c-lock'); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', key);
    z.querySelector('.pd-zoom__x').addEventListener('click', close);
    img.addEventListener('pointerdown', function (e) { drag = true; moved = false; sx = e.clientX - tx; sy = e.clientY - ty; startY = e.clientY; img.setPointerCapture(e.pointerId); });
    img.addEventListener('pointermove', function (e) { if (!drag) return; if (Math.abs(e.clientY - startY) > 6 || Math.abs(e.clientX - sx - tx) > 6) moved = true; if (zoomed) { tx = e.clientX - sx; ty = e.clientY - sy; apply(); } });
    img.addEventListener('pointerup', function (e) {
      drag = false;
      if (!zoomed && moved && e.clientY - startY > 90) { close(); return; }
      if (moved) return;
      if (!zoomed) { var r = img.getBoundingClientRect(); var cx = e.clientX - (r.left + r.width / 2), cy = e.clientY - (r.top + r.height / 2); tx = -cx * 1.4; ty = -cy * 1.4; zoomed = true; } else { zoomed = false; tx = ty = 0; }
      z.classList.toggle('is-zoomed', zoomed); apply();
    });
    z.querySelector('.pd-zoom__x').focus();
  }

  /* variants */
  function variantFrom() {
    if (!form) return null; var vals = $$('[data-pd-option]:checked').map(function (i) { return i.value; });
    return (data.variants || []).filter(function (v) { return v.options.every(function (o, k) { return vals[k] === undefined || o === vals[k]; }); })[0];
  }
  function setVariant(v) {
    if (!v) return;
    $$('input[name=id]').forEach(function (i) { i.value = v.id; });
    $$('[data-pd-price]', document).forEach(function (el) { el.textContent = money(v.price); });
    var cmp = v.compare_at_price > v.price;
    $$('[data-pd-was]', document).forEach(function (el) { el.textContent = cmp ? money(v.compare_at_price) : ''; el.hidden = !cmp; });
    var save = $('[data-pd-save]'); if (save) { save.hidden = !cmp; if (cmp) save.textContent = 'You save ' + money(v.compare_at_price - v.price) + ' (' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%)'; }
    $$('[data-pd-vlabel]', document).forEach(function (el) { el.textContent = v.title; });
    $$('[data-pd-add]', document).forEach(function (b) { b.disabled = !v.available; var l = b.querySelector('[data-label]'); if (l) l.textContent = v.available ? b.dataset.labelOn : b.dataset.labelOff; });
    $$('[data-pd-wa]', document).forEach(function (a) { a.href = window.CC ? CC.waUrl((data.waPrefix || '') + data.title + ' (' + v.title + ')\n' + location.origin + data.url + '?variant=' + v.id) : a.href; });
    if (v.media_index != null && v.media_index > -1) goTo(v.media_index);
    try { history.replaceState(null, '', data.url + '?variant=' + v.id); } catch (e) {}
  }
  root.addEventListener('change', function (e) { if (e.target.matches('[data-pd-option]')) setVariant(variantFrom()); });

  /* quantity steppers */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return; var inp = b.parentNode.querySelector('input'); var n = Math.max(1, (parseInt(inp.value, 10) || 1) + (+b.dataset.qty)); inp.value = n;
  });

  /* sticky add bar */
  var bar = document.querySelector('[data-pd-sticky]'), main = $('[data-pd-mainbtn]');
  if (bar && main && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { var on = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; bar.classList.toggle('is-on', on); document.documentElement.classList.toggle('pd-sticky-on', on); bar.setAttribute('aria-hidden', !on); }).observe(main);
    bar.addEventListener('click', function (e) { if (e.target.closest('[data-pd-sticky-add]')) { e.preventDefault(); var s = form.querySelector('[data-add]'); if (s) { if (form.requestSubmit) form.requestSubmit(s); else s.click(); } } });
  }

  /* share */
  function share() {
    var url = location.href;
    if (navigator.share) { navigator.share({ title: data.title, url: url }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { window.CC && CC.toast('Link copied'); });
  }

  /* recently viewed */
  try { var k = 'cc-recent', list = JSON.parse(localStorage.getItem(k) || '[]').filter(function (h) { return h !== data.handle; }); list.unshift(data.handle); localStorage.setItem(k, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  paint();
})();
